// extracted by mini-css-extract-plugin
export var checkbox = "_83-0";
export var circle = "_83-3";
export var horizontalContainer = "_83-7";
export var sm = "_83-5";
export var switch0 = "_83-2";
export var switchDisabled = "_83-8";
export var switchEnabled = "_83-1";
export var textSwitchContainer = "_83-9";
export var textSwitchOption = "_83-a";
export var textSwitchOptionSelected = "_83-b";
export var verticalContainer = "_83-6";
export var xs = "_83-4";